import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

function flattenLevels(root) {
  const levels = [];
  let frontier = root ? [root] : [];
  while (frontier.length) {
    levels.push(frontier);
    const next = [];
    frontier.forEach((n) => (n.children || []).forEach((c) => next.push(c)));
    frontier = next;
  }
  return levels;
}

export default function ApplicatorNetworkTree() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [openId, setOpenId] = useState(null);
  useEffect(() => { api.get("/applicator/network").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-500">Loading…</div>;

  const rows = flattenLevels(data.tree);

  return (
    <div data-testid="applicator-network-page">
      <h1 className="serif-head text-3xl lg:text-4xl mb-2">{t("network")}</h1>
      <p className="text-sm text-gray-400 mb-6">{t("referral_code")}: <span className="gold-text">{data.referral_code}</span></p>

      <div className="grid grid-cols-5 gap-2 mb-8" data-testid="network-levels">
        {[1, 2, 3, 4, 5].map((l) => (
          <div key={l} className="hair-border bg-white/[0.02] p-3 text-center">
            <p className="text-[10px] text-gray-500">Level {l}</p>
            <p className="font-display text-xl gold-text">{data.level_counts?.[l] || 0}</p>
          </div>
        ))}
      </div>

      <div className="hair-border bg-white/[0.02] p-6 overflow-x-auto" data-testid="network-tree">
        <div className="min-w-max flex flex-col items-center gap-6">
          {rows.map((row, li) => (
            <div key={li} className="flex flex-col items-center">
              {li > 0 && <div className="w-px h-5 bg-[#C9A45C]/40 mb-6" />}
              <div className="flex gap-4 lg:gap-8">
                {row.map((n) => {
                  const open = openId === n.applicator_id;
                  return (
                    <button key={n.applicator_id} onClick={() => setOpenId(open ? null : n.applicator_id)} data-testid={`node-${n.applicator_code}`}
                      className="hair-border bg-white/[0.03] hover:bg-white/[0.06] px-4 py-3 text-center min-w-[130px] transition-colors">
                      <p className="text-sm font-display">{n.name}</p>
                      <p className="text-[10px] gold-text tracking-wide">{n.applicator_code}</p>
                      {open && (
                        <div className="mt-2 pt-2 border-t border-white/10 text-[11px] text-gray-400 space-y-0.5">
                          <p>{n.city || "—"}</p><p>{n.level}</p>
                          <p>Certified: {n.certified_services}</p><p>Jobs: {n.jobs_completed}</p>
                        </div>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="mt-6 text-[11px] text-gray-600 max-w-2xl leading-relaxed">{t("disclaimer")}</p>
    </div>
  );
}
